import styled, { css } from 'styled-components';
import { Link } from "raviger";

const link = css`
  font-size: 1rem;
  color: ${(props) => props.theme.badge.backgroundColor};
  margin-top: -0.3rem;
  margin-bottom: 2rem;
`

export const ProgramName = styled.div`
  font-size: 2rem;
  font-weight: 600;
`;

export const Organization = styled(Link)`
  ${link}
`;

export const NotMember = styled.span`
  ${link}
`;

export const Description = styled.div`
  margin: 1rem 0;

  > div {
    > span {
      &:first-child {
        font-weight: 600;
      }
    }

    > a {
      font-size: 1rem;
      color: ${(props) => props.theme.badge.backgroundColor};
    }

    &:first-child {
      font-weight: 600;
    }
  }
`;

export const Elegibility = styled.p`
  white-space: pre-wrap;
`;

export const Criteria = styled.div`
  > div {
    font-weight: 600;
  }

  > ul {
    list-style-type: none;
    padding: 0;
  }
`;

export const List = styled.div`
  > ul {
    list-style: square;
    padding-left: 1rem;
    padding-top: 1rem;
  }
`;
